// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editable {
  font-family: sans-serif;
  min-height: 100px;
  border: 0.5px solid #aaa;
  padding: 32px 5px 5px 5px;
  resize: none;
  width: 33.1rem;
  margin-top: 9px;
  border-radius: 4px;
  outline: 0px !important;
  -webkit-box-shadow: none !important;
}

.editable:focus {
  box-shadow: none !important;
}

textarea.editable {
  font-family: sans-serif;
  /* width: -webkit-fill-available;
  width: 99%; */
}

button {
  min-width: 28px;
  padding: 3px 4px 3px 4px;
  margin: 2px 5px 0 0;
  font-size: 12px;
  font-weight: 500;
  border-radius: 10px;
  border: 0px;
  background: #e8ddf5;
  font-family: system-ui;

}

.tagdiv {
  position: absolute;
  top: 3.2rem;
  left: 1.2rem;
}

.textareaTitle {
  top: 7px !important;
}

.tagdiv>input[type="button" i] {
  min-width: 28px;
  padding: 3px 4px 4px 4px;
  margin: 2px 5px 0 0;
  font-size: 12px;
  font-weight: 500;
  border-radius: 10px;
  border: 0px;
  background: #1fb5ad;
  font-family: system-ui;
  color: #ffffff;

}

@media only screen and (max-width: 500px) {
  .editable {
    width: 15rem !important;
  }
}

@media only screen and (max-width: 700px) {
  .editable {
    width: 18rem !important;
  }
}

@media only screen and (max-width: 800px) {
  .editable {
    width: 18rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/common/EditableTextField/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB;eACa;AACf;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;;AAExB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;;AAEhB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".editable {\r\n  font-family: sans-serif;\r\n  min-height: 100px;\r\n  border: 0.5px solid #aaa;\r\n  padding: 32px 5px 5px 5px;\r\n  resize: none;\r\n  width: 33.1rem;\r\n  margin-top: 9px;\r\n  border-radius: 4px;\r\n  outline: 0px !important;\r\n  -webkit-box-shadow: none !important;\r\n}\r\n\r\n.editable:focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\ntextarea.editable {\r\n  font-family: sans-serif;\r\n  /* width: -webkit-fill-available;\r\n  width: 99%; */\r\n}\r\n\r\nbutton {\r\n  min-width: 28px;\r\n  padding: 3px 4px 3px 4px;\r\n  margin: 2px 5px 0 0;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  border-radius: 10px;\r\n  border: 0px;\r\n  background: #e8ddf5;\r\n  font-family: system-ui;\r\n\r\n}\r\n\r\n.tagdiv {\r\n  position: absolute;\r\n  top: 3.2rem;\r\n  left: 1.2rem;\r\n}\r\n\r\n.textareaTitle {\r\n  top: 7px !important;\r\n}\r\n\r\n.tagdiv>input[type=\"button\" i] {\r\n  min-width: 28px;\r\n  padding: 3px 4px 4px 4px;\r\n  margin: 2px 5px 0 0;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  border-radius: 10px;\r\n  border: 0px;\r\n  background: #1fb5ad;\r\n  font-family: system-ui;\r\n  color: #ffffff;\r\n\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n  .editable {\r\n    width: 15rem !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 700px) {\r\n  .editable {\r\n    width: 18rem !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 800px) {\r\n  .editable {\r\n    width: 18rem !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
